import { SimpleGroupItem } from '@nostr/gadgets/lists'
import { useFetchRelayInfo } from '@/hooks/useFetchRelayInfo'
import { useAsync } from 'react-use'
import client from '@/services/client.service'
import { SecondaryPageLink } from '@/PageManager'
import { toNote } from '@/lib/link'
import { AddressPointer } from '@nostr/tools/nip19'

export default function SimpleGroupCard({ group }: { group: SimpleGroupItem }) {
  const { relayInfo } = useFetchRelayInfo(group.relay)

  const { value: event } = useAsync(async () => {
    if (!relayInfo?.self) return undefined
    return client.fetchEvent({
      pubkey: relayInfo.self,
      kind: 39000,
      identifier: group.groupId,
      relays: [group.relay]
    })
  }, [relayInfo?.self, group.groupId, group.relay])

  const name = event?.tags.find((t) => t[0] === 'name')?.[1]
  const picture = event?.tags.find((t) => t[0] === 'picture')?.[1]

  const addrPointer: AddressPointer | null = relayInfo?.self
    ? { pubkey: relayInfo.self, kind: 39000, identifier: group.groupId, relays: [group.relay] }
    : null

  const content = (
    <>
      {picture && <img src={picture} alt="" className="w-8 h-8 rounded object-cover shrink-0" />}
      <div className="flex-1 w-0">
        <div className="truncate text-sm font-medium">
          {name || group.name || group.groupId.slice(0, 12)}
        </div>
        <div className="truncate text-xs text-muted-foreground">{group.relay}</div>
      </div>
    </>
  )

  const className = 'flex items-center gap-2 px-3 py-2'

  if (!addrPointer) return <div className={className}>{content}</div>

  return (
    <SecondaryPageLink to={toNote(addrPointer)} className={className}>
      {content}
    </SecondaryPageLink>
  )
}
